module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"edit":"править","available":"доступно","Rename Accounts Category":"Сменить имя категории","Change position":"Изменить порядок","No accounts":"Нет счетов"}}')
  delete Component.options._Ctor
}
